module.exports = __webpack_public_path__ + "static/img/doudizhu.168d222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/doudizhu.jpg
// module id = nFl9
// module chunks = 0